
import { mapGetters } from "vuex";
import { defineComponent } from "vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import { AppItem, AppsHelper } from "@/helpers/AppsHelper";
import { AppEnum } from "@/models/enum/AppEnum";
import { AuthRestService } from "@/services/rest/AuthRestService";

export default defineComponent({
  components: { BaseContainer },
  computed: {
    otherApps(): AppItem[] {
      return AppsHelper.getOtherAuthorizedApps(AppEnum.MGMT);
    },
    ...mapGetters(["isAuthenticated"]),
    ...mapGetters("customer_settings", ["getCustomerMainDomain"])
  },
  methods: {
    appTitle(app: AppItem): string {
      const key = `apps.${app.code}`;

      return this.$te(key) ? this.$t(key) : app.code;
    },
    appDescription(app: AppItem): string {
      const key = `apps.descriptions.${app.code}`;

      return this.$te(key) ? this.$t(key) : '';
    },
    async login() {
      window.location.href = await AuthRestService.getInstance().getLoginUrl();
    }
  }
});
